import { get, isArray } from 'lodash';
import React, { FC } from 'react';
import { FOERDERPROGRAMM_ERKLAERUNG_UND_UNTERLAGEN_PATHS } from 'src/lib/constants/componentsPath';
import CreateTable from '../../../../../../../components/ui-component/form-component/create-form/CreateTable';
import { useApplication } from '../../../../../../../context/ApplicationContext';
import { ANTRAG_TYP, ART_DES_ANTRAGS, FORM_FIELDS_TYPES } from '../../../../../../../lib/constants/constant';
import { FormStrucItem } from '../../../../../../../lib/types/types';
import { NonRequired } from '../../../../../../../lib/validation/ValidationTypes';
import { addIndexesToPath, checkReadOnlyInUeberarbeitung } from '../../../../../../../utils/helper';
import ApplicationHeading from '../../../../application-heading/ApplicationHeading';

// import schemas
import AntragSchema from '../../../../../../../lib/paths/antrag_FULL_Paths.json';
const P = AntragSchema.attributes;

const OptionaleAnlagenGlobal: FC<{ hasComment?: boolean }> = ({ hasComment }) => {
	const { application, setApplicationProperty, readOnly } = useApplication();

	const updatedReadOnly = checkReadOnlyInUeberarbeitung(application, readOnly, hasComment);

	const antragsTyp = get(application, P.Allgemein_Typ.path, '');
	const foerderprogramm = get(application, P.Foerderprogramm.path, {});
	const isFormantrag = get(application, P.Allgemein_Art_Des_Antrags.path, '') === ART_DES_ANTRAGS.Formantrag;
	const paths =
		antragsTyp === ANTRAG_TYP.Skizze ? FOERDERPROGRAMM_ERKLAERUNG_UND_UNTERLAGEN_PATHS.Skizze
		: isFormantrag ? FOERDERPROGRAMM_ERKLAERUNG_UND_UNTERLAGEN_PATHS.Formantrag
		: FOERDERPROGRAMM_ERKLAERUNG_UND_UNTERLAGEN_PATHS.Antrag;

	return (
		<>
			<ApplicationHeading
				title={get(foerderprogramm, paths.OptionaleAnlageUnterTitel, 'Optionale Anlagen')}
				description={get(foerderprogramm, paths.OptionaleAnlageBeschreibung, '')}
			/>

			<CreateTable
				formStruc={formStrucOptionaleAnlagen(application)}
				formValues={application}
				updateFormValuesFunc={setApplicationProperty}
				readOnly={updatedReadOnly}
				columnsLabel={columnLabels()}
				size='small'
			/>
		</>
	);
};

export default OptionaleAnlagenGlobal;

const columnLabels = () => {
	let labels = [{ label: 'Bezeichnung des Dokuments' }, 'Datei', 'Bemerkungen'];
	return labels;
};

const formStrucOptionaleAnlagen = (application: any) => {
	let struc: FormStrucItem[] = [];
	const optionaleAnlagen = get(application, P.Anlagen_Optionale_Anlagen.path, []);

	if (isArray(optionaleAnlagen) && optionaleAnlagen.length > 0) {
		for (const [i, ele] of optionaleAnlagen.entries()) {
			if (get(ele, 'Bezeichnung_Des_Dokuments')) {
				struc.push({
					fields: [
						{
							type: FORM_FIELDS_TYPES.label,
							path: 't.t',
							label: get(ele, 'Bezeichnung_Des_Dokuments'),
							tooltip: get(ele, 'Erlaeuterungen_Zum_Dokument', ''),
						},
						{
							type: P.Anlagen_Optionale_Anlagen.schema.attributes.Datei.type,
							path: addIndexesToPath(P.Anlagen_Optionale_Anlagen.schema.attributes.Datei.path, [`${i}`], ['Anlagen_Optionale_Anlagen']),
						},
						{
							type: P.Anlagen_Optionale_Anlagen.schema.attributes.Bemerkung_Der_Antragsteller_42_in.type,
							path: addIndexesToPath(
								P.Anlagen_Optionale_Anlagen.schema.attributes.Bemerkung_Der_Antragsteller_42_in.path,
								[`${i}`],
								['Anlagen_Optionale_Anlagen'],
							),
							validation: [{ validateFunction: NonRequired }],
						},
					],
				});
			}
		}
	}
	return struc;
};
